module.exports = __webpack_public_path__ + "static/img_4.22f2131e.jpg";